module.exports = function() {
	return new Worker(__webpack_public_path__ + "4be0a2bf318b439bb529.placemarks.wrkr.js");
};